import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalExpenseCFStep = (state) => state.get('medicalExpenseCFStep');

const makeSelectMedicalExpenseCFStep = () => createSelector(
  selectMedicalExpenseCFStep,
  (stepMedicalExpenseCFState) => ({
    relationshipToYou: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'relationshipToYou']),
      ''
    ),
    nationalIdOrVisa: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'nationalIdOrVisa']),
      ''
    ),
    id: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'id']),
      ''
    ),
    purposeOfTrip: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'purposeOfTrip']),
      ''
    ),
    didYouContactAssistanceCompany: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'didYouContactAssistanceCompany']),
      ''
    ),
    ifOtherPleaseDescribe: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifOtherPleaseDescribe']),
      ''
    ),
    disYouContactAssistanceCompany: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'disYouContactAssistanceCompany']),
      ''
    ),
    assistanceCaseReferenceNumberFileNumber: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'assistanceCaseReferenceNumberFileNumber']),
      ''
    ),
    didYouHaveOtherMedicalInsurance: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'didYouHaveOtherMedicalInsurance']),
      ''
    ),
    insuranceCarriersName: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'insuranceCarriersName']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'policyId']),
      ''
    ),
    areYouACitizenOfTheEuropeanUnion: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'areYouACitizenOfTheEuropeanUnion']),
      ''
    ),
    forEUCitizens: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'forEUCitizens']),
      ''
    ),
    ifYesWasTheEHIC: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifYesWasTheEHIC']),
      ''
    ),
    ifNoPleaseExplain: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifNoPleaseExplain']),
      ''
    ),

    accidentStartDate: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'accidentStartDate']),
      ''
    ),
    accidentFirstTreatment: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'accidentFirstTreatment']),
      ''
    ),
    nameOfPhysicianFacilityFirstContacted: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'nameOfPhysicianFacilityFirstContacted']),
      ''
    ),
    addressForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'addressForHospital']),
      ''
    ),
    cityOrTownForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'cityOrTownForHospital']),
      ''
    ),
    countryForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'countryForHospital']),
      ''
    ),
    emailForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'emailForHospital']),
      ''
    ),
    phoneNumberForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'phoneNumberForHospital']),
      ''
    ),
    postalCodeForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'postalCodeForHospital']),
      ''
    ),
    isTheClaimTheResultOfAniLLness: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'isTheClaimTheResultOfAniLLness']),
      ''
    ),
    alternativeTreatment: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'alternativeTreatment']),
      ''
    ),
    accidentStartDateForIllness: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'accidentStartDateForIllness']),
      ''
    ),
    symptoms: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'symptoms']),
      ''
    ),
    detailsForIllness: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'detailsForIllness']),
      ''
    ),
    isTheClaimTheResultOfAccidentOrInjury: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'isTheClaimTheResultOfAccidentOrInjury']),
      ''
    ),
    ifOtherPleaseDescribeForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifOtherPleaseDescribeForHospital']),
      ''
    ),
    wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity']),
      ''
    ),
    place: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'place']),
      ''
    ),
    accidentDate: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'accidentDate']),
      ''
    ),
    accidentTime: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'accidentTime']),
      ''
    ),
    detailsForAccident: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'detailsForAccident']),
      ''
    ),
    wasTheAccidentOrInjuryTheResultOfPlayingASportODueToAHazardousActivity: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'wasTheAccidentOrInjuryTheResultOfPlayingASportODueToAHazardousActivity']),
      ''
    ),
    nameOfPhysicianFacilityFirstContactedForPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'nameOfPhysicianFacilityFirstContactedForPhysician']),
      ''
    ),
    addressForPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'addressForPhysician']),
      ''
    ),
    cityOrTownForPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'cityOrTownForPhysician']),
      ''
    ),
    countryForPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'countryForPhysician']),
      ''
    ),
    postalCodeForPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'postalCodeForPhysician']),
      ''
    ),
    phoneNumberForPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'phoneNumberForPhysician']),
      ''
    ),
    facilityName: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'facilityName']),
      ''
    ),
    addressForProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'addressForProvide']),
      ''
    ),
    cityOrTownForProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'cityOrTownForProvide']),
      ''
    ),
    countryForProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'countryForProvide']),
      ''
    ),
    postalCodeForProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'postalCodeForProvide']),
      ''
    ),
    phoneNumberForProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'phoneNumberForProvide']),
      ''
    ),
    admitDate: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'admitDate']),
      ''
    ),
    timeOfAdmission: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'timeOfAdmission']),
      ''
    ),
    dischargeDate: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'dischargeDate']),
      ''
    ),
    timeOfDischarge: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'timeOfDischarge']),
      ''
    ),
    expensesClaimed: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'expensesClaimed']),
      ''
    ),
    currencyForProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'currencyForProvide']),
      ''
    ),
    didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness']),
      ''
    ),
    wereYouTravelingToReceiveMedicalTreatment: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'wereYouTravelingToReceiveMedicalTreatment']),
      ''
    ),
    ifYesWhenDidYouLearnOfTheAlternativeTreatment: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifYesWhenDidYouLearnOfTheAlternativeTreatment']),
      ''
    ),
    whoRecommendedTheTreatment: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'whoRecommendedTheTreatment']),
      ''
    ),
    areYouPregnant: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'areYouPregnant']),
      ''
    ),
    ifYesNumberOfWeeks: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifYesNumberOfWeeks']),
      ''
    ),
    changeTo: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'changeTo']),
      ''
    ),
    ifYesNameOfPhysicianCurrentlyTreatingThis: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'ifYesNameOfPhysicianCurrentlyTreatingThis']),
      ''
    ),
    prescriptionMedicinesNotInjury: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'prescriptionMedicinesNotInjury']) && stepMedicalExpenseCFState.getIn(['form', 'prescriptionMedicinesNotInjury']).toJS(), ''),
    prescriptionMedicinesForInjury: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'prescriptionMedicinesForInjury']) && stepMedicalExpenseCFState.getIn(['form', 'prescriptionMedicinesForInjury']).toJS(), ''),
    // NEW FIELDS
    lossInformationItemsMedicalExpense: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'lossInformationItemsMedicalExpense']) && stepMedicalExpenseCFState.getIn(['form', 'lossInformationItemsMedicalExpense']).toJS(), ''),
    otherDescriptionPleaseProvide: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'otherDescriptionPleaseProvide']),
      ''
    ),
    // NEW FIELDS
    medicalProviderName: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'medicalProviderName']),
      ''
    ),
    descriptionOfexpense: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'descriptionOfexpense']),
      ''
    ),
    expenseDateForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'expenseDateForHospital']),
      ''
    ),
    actualCostForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'actualCostForHospital']),
      ''
    ),
    currencyForHospital: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'currencyForHospital']),
      ''
    ),

    companyNameLoss: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'currentAmountOfLoss']), ''),
    amountClaimed: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'amountClaimed']), ''),
    currentClaimed: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'currentClaimed']), ''),
    haveYouReceivedReimbursement: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'enableTime']), null),
    selectedClaimFor: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'selectedClaimFor']) && stepMedicalExpenseCFState.getIn(['form', 'selectedClaimFor']).toJS(), ''),
  })
);

const makeSelectMedicalExpenseCFStepErrors = () =>
  createSelector(selectMedicalExpenseCFStep, (state) => state.get('errors'));

export {
  makeSelectMedicalExpenseCFStep,
  makeSelectMedicalExpenseCFStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/selectors.js